export default {
  // Navigation
  'nav.home': 'Trang chủ',
  'nav.product': 'Sản phẩm',
  'nav.cases': 'Trường hợp thành công',
  'nav.findDoctor': 'Hướng dẫn phụ huynh',
  'nav.about': 'Về chúng tôi',
  'nav.doctorLogin': 'Đăng nhập bác sĩ',
  
  // Common
  'common.learnMore': 'Tìm hiểu thêm',
  'common.contactUs': 'Liên hệ chúng tôi',
  'common.submit': 'Gửi',
  'common.search': 'Tìm kiếm',
  
  // Footer
  'footer.quickLinks': 'Liên kết nhanh',
  'footer.contact': 'Liên hệ chúng tôi',
  'footer.followUs': 'Theo dõi chúng tôi',
  'footer.copyright': '© 2024 Mirókids. Đã đăng ký bản quyền.',
  'footer.phone': 'Điện thoại',
  'footer.email': 'Email',
  'footer.address': 'Địa chỉ',
};
